<script>
  import Icon from "@iconify/svelte";
  import basebloxLogo from "../../baseblox.svg";
  import { t } from "../lib/i18n.svelte.js";
  import { login } from "../lib/stores/auth.svelte.js";
  import { push } from "svelte-spa-router";
  import { addToast } from "../components/Toast.svelte";
  import LanguageSwitcher from "../components/LanguageSwitcher.svelte";

  let apiKey = $state("");
  let loading = $state(false);
  let error = $state("");

  async function handleSubmit(e) {
    e.preventDefault();
    loading = true;
    error = "";
    try {
      await login(apiKey);
      push("/dashboard");
    } catch (err) {
      error = err.message || t("login.error");
      addToast(error, "error");
    } finally {
      loading = false;
    }
  }
</script>

<div class="ui-login-shell min-h-screen flex items-center justify-center px-4 py-10 text-zinc-100">
  <div class="w-full max-w-5xl ui-login-grid items-stretch">
    <aside class="order-2 flex flex-col justify-center gap-6 p-6 sm:p-8 lg:order-1 lg:pr-10">
      <div class="space-y-4">
        <h2 class="flex items-center gap-3 text-2xl font-light leading-snug text-neutral-100 sm:text-3xl lowercase">
          <img src={basebloxLogo} alt="BaseBlox" class="h-10 w-10 shrink-0 rounded-xl" />
          {t("login_acdev_headline")}
        </h2>
        <p class="text-sm leading-relaxed text-neutral-400">
          {t("login_acdev_description")}
        </p>
        <a
          href={`https://${t("login_acdev_link")}`}
          target="_blank"
          rel="noopener noreferrer"
          class="ui-login-link inline-flex items-center gap-1.5 text-sm"
        >
          {t("login_acdev_link")}
          <Icon icon="mdi:arrow-top-right" class="h-4 w-4" />
        </a>
      </div>
      <div class="text-sm text-neutral-500">
        {t("login_acdev_licensing")} -
        <a href={`mailto:${t("login_acdev_contact")}`} class="ui-login-link">
          {t("login_acdev_contact")}
        </a>
      </div>
    </aside>

    <div class="ui-login-separator order-2 hidden self-stretch lg:block" aria-hidden="true"></div>
    <section class="ui-card ui-login-card order-1 flex flex-col p-8 sm:p-10 lg:order-3">
      <div class="mb-6 flex items-center justify-end">
        <LanguageSwitcher />
      </div>

      <div class="mb-8 flex flex-col items-center gap-3 text-center">
        <div class="ui-login-badge flex h-14 w-14 items-center justify-center">
          <Icon icon="streamline:cloud-share" class="h-8 w-8" />
        </div>
        <div class="text-3xl font-light tracking-wide text-neutral-100 lowercase">
          {t("app.name")}
        </div>
        <div class="text-sm text-neutral-400">{t("app.tagline")}</div>
      </div>

      <form onsubmit={handleSubmit} class="mx-auto w-full max-w-sm space-y-3">
        {#if error}
          <div class="rounded-lg border border-rose-800/60 bg-rose-950/40 px-4 py-3 text-sm text-rose-200">
            {error}
          </div>
        {/if}

        <input
          type="password"
          bind:value={apiKey}
          required
          placeholder={t("login.placeholder")}
          class="ui-login-input px-3 py-2.5 text-center"
          disabled={loading}
          autocomplete="current-password"
        />

        <button
          type="submit"
          class="ui-login-button inline-flex h-11 w-full items-center justify-center gap-2 px-4 py-2.5 text-sm font-normal lowercase"
          disabled={loading}
        >
          {#if loading}
            <Icon icon="mdi:loading" class="h-4 w-4 animate-spin" />
          {/if}
          {loading ? t("common.loading") : t("login.sign_in")}
        </button>
      </form>
    </section>
  </div>
</div>
